import React, { useState, useEffect } from 'react';
import { useObservable } from 'rxjs-hooks';
import { useDispatch } from 'react-redux';
import { authAPI } from '../../_services';
import {
  Grid,
  Container,
  Button,
  Input,
  Header,
  Segment
} from 'semantic-ui-react';
const qrcode = require('qrcode');

const TwoFactorAuth = ({ location = null }) => {
  const loginUser = useObservable(() => authAPI.loginUser);

  const [qrImage, setQRImage] = useState(null);
  const [token, setToken] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!loginUser || !loginUser.tfa_secret) return;

    qrcode.toDataURL(loginUser.tfa_url, function(err, image) {
      if (!err) setQRImage(image);
    });
  }, [loginUser]);

  const authenticate2FA = () => {
    authAPI.login2FA(loginUser.user_name, token, null, location, dispatch);
  };

  return (
    <div>
      <Container>
        <Grid centered padded textAlign="center" style={{ height: '90vh' }}>
          <Grid.Column style={{ maxWidth: 450 }}>
            <Segment>
              <Header as="h2" textAlign="left">
                Two Factor Authentication
              </Header>
              {qrImage && (
                <>
                  <p>
                    Trojan Energy portals are protected by 2-Factor
                    Authentication. Please install the Google Authenticator or
                    Authy app on a secure mobile device and scan the QR code
                    below.
                  </p>
                  <img src={qrImage} alt="QR" />
                </>
              )}
              <p
                sub
                color="grey"
                style={{ marginTop: '15px', marginBottom: '5px' }}
              >
                <b>
                  Please enter the 6-digit token from your authenticator app
                </b>
              </p>
              <Input
                type="text"
                name="token"
                onChange={(_, { value }) => setToken(value)}
              />
              <br />
              <br />
              <Button onClick={() => authenticate2FA()} color="olive">
                Authenticate
              </Button>
              <br />
              <br />
              {!qrImage &&
                "If you can't access your token, please contact technical support."}
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};

export { TwoFactorAuth };
